import './Template/_Fragment/Navigation/Navigation.js'
import './Component/_Fragment/DisplayText/DisplayText.js'
import "./Component/_Fragment/SliderCollection/SliderCollection.js";
import './Component/Form/Form.js'
import './Assets/Scripts/plyr-video.js'
import './Template/HomePage/HomePage.js'
import './Template/_Fragment/ColorWheelOverlay/ColorWheelOverlay.js'
import './Component/TeamContainer/Member/MemberColor.js'

import { slider } from "./Component/_Fragment/SliderCollection/SliderCollection.js";

document.addEventListener('Neos.NodeCreated', function(event) {
    const element = event.detail.element;

    if(element.querySelector('.slider')) {
        slider()
    }
})
